import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import "./Login.css";
import loginImg from "../assets/images/logo.svg";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (email === "Admin" && password === "demo") {
      setSuccess("Login successful!");
      setError("");

      // Redirect to User Feed
      setTimeout(() => {
        navigate("/user");
      }, 300);
    } else {
      setError("Invalid username or password");
      setSuccess("");
    }
  };

  return (
    <div className="login-wrapper">
      <div className="logo">
        <div className="logo-circle">
          <img src={loginImg} alt="Login" className="login-image" />
        </div>
      </div>

      <div className="login-card">
        <h3>Log in</h3>
        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>

        {/* Error / Success */}
        {error && <p className="error-msg">{error}</p>}
        {success && <p className="success-msg">{success}</p>}

        <form onSubmit={handleSubmit}>
          <label>Username</label>
          <input
            type="text"
            placeholder="Username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <label>Password</label>
          <input
            type="password"
            placeholder="*******"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <div className="options">
            <label>
              <input className="checkbox" type="checkbox" /> Remember me
            </label>
            <span className="forgot">Forgot password?</span>
          </div>

          <button type="submit" className="login-btn">
            Login
          </button>
        </form>

        {/* Signup */}
        <p className="signup-text">
          Don’t have an account? <Link to="/signup">Sign up</Link>
        </p>

        {/* Footer Links */}
        <div className="footer-links">
          <Link to="/privacy">Privacy Policy</Link>
          <span>•</span>
          <Link to="/terms">Terms of Use</Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
